<div class="content-body">
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="checkAddTenant ? 'Add Tenant' : ''" (addEvent)="toggleExample($event)"> </app-breadcrumb>
    <div class="container-fluid">
        <div class="card">

            <div class="card-body p-0">

                <form [formGroup]="searchForm" (ngSubmit)="onSearch()" autocomplete="off">
                <div class="row" *ngIf="searchForm">
                    <div class="col-md-2 mt-3 ps-4">
                        <div class="mb-3">
                            <input type="text" class="form-control input-default search-textbox-height" placeholder="Name" formControlName="search" autocomplete="off"/>
                        </div>
                    </div>
                    <div class="col-md-2 mt-3" *ngIf="checkManagedByFilter">
                        <select2 ngDefaultControl [data]="users" [templates]="template"
                          class="select2" value="" placeholder="Managed by" formControlName="managed_by" (update)="handleSearch('')">
                          <ng-template #template let-data="data">{{data?.name}}</ng-template>
                        </select2>
                    </div>
                    <div class="col-md-2 mt-3">
                        <select2 ngDefaultControl [data]="cities_list" [templates]="template"
                          class="select2" placeholder="Select city" formControlName="city" (update)="handleSearch('')">
                          <ng-template #template let-data="data">{{data?.name}}</ng-template>
                        </select2>
                    </div>
                    <!-- <div class="col-md-3 mt-3">
                        <select2 ngDefaultControl [data]="states_list" [templates]="template"
                          class="select2" placeholder="Select state" formControlName="state" (update)="handleSearch('')">
                          <ng-template #template let-data="data">{{data?.name}}</ng-template>
                        </select2>
                    </div> -->
                    <div class="col-md-3 mt-3">
                        <ng-select [items]="propertiesList" class="select2" bindValue="value" bindLabel="label" placeholder="Select Properties"
                            [typeahead]="searchInput$" [virtualScroll]="true" formControlName="property" (scrollToEnd)="onScrollToEnd()" (change)="handleSearch('')">
                        </ng-select>
                    </div>
                    <div class="col-md-2 mt-3">
                        <select class="form-select" formControlName="status" (change)="handleSearch('')">
                            <option value="null" disabled selected>Select Status</option>
                            <option>Active</option>
                            <option>Inactive</option>
                        </select>
                    </div>

                    <div #advancedSearchPopup class="offcanvas offcanvas-end customeoff {{ offcanvasSearch ? 'show':''}}" tabindex="-1" id="offcanvasSearch" data-bs-backdrop="static">
                        <div class="offcanvas-header">
                        <h5 class="modal-title" id="#gridSystemModal">Advanced Filter</h5>
                          <button type="button" class="btn-close" (click)="searchClose()">
                              <i class="fa-solid fa-xmark"></i>
                          </button>
                        </div>
                        <div class="offcanvas-body">
                          <div class="-fluid" >
                                  <div class="row">
                                      <div class="col-xl-6 mb-3">
                                          <label for="exampleFormControlInput1-1" class="form-label">Address</label>
                                          <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="Address" formControlName="address">
                                      </div>
                                      <div class="col-xl-6 mb-3">
                                          <label for="exampleFormControlInput1-2" class="form-label">Contact Number</label>
                                          <input type="text" class="form-control" id="exampleFormControlInput1-2" placeholder="Contact Number" formControlName="contact_no">
                                      </div>
                                  </div>
                                  <div>
                                      <button class="btn btn-primary ms-1 me-3" type="button" (click)="handleSearch('')">Search</button>
                                      <button class="btn btn-danger lightme-1" type="button" (click)="searchClose()">Cancel</button>
                                  </div>

                            </div>
                        </div>
                      </div>
                      @if(offcanvasSearch){
                        <div class="offcanvas-backdrop fade show" (click)="toggleSearch()"></div>
                    }
                </div>
            </form>
                <div class="row">
                    <div class="col-md-12">
                        <a class="btn btn-primary btn-sm me-3 mb-3 float-end" href="javascript:void(0);" (click)="toggleSearch()">Advanced Search</a>
                        <button class="btn btn-danger btn-sm  mt-0 float-end me-3"  type="button" (click)="resetSearchForm()" [disabled]="!disableClear">Clear</button>
                    </div>
                </div>

                    <div class="row">
                        <div class="col-xl-12">
                        <div class="table-responsive active-projects style-1 ItemsCheckboxSec shorting dataTables_wrapper">
                            <table id="empoloyees-tbl" class="table mb-0" matSort (matSortChange)="sortData($event)">
                                <thead>
                                    <tr>
                                        <th>Join Date</th>
                                        <th mat-sort-header="first_name">First name</th>
                                        <th mat-sort-header="last_name">Last Name</th>
                                        <th mat-sort-header="email">Email</th>
                                        <th>Rent</th>
                                        <th>Rent End Date</th>
                                        <!-- <th mat-sort-header="status">Status</th> -->
                                        <th>Property</th>
                                        <th>Active</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for(item of allData.data; track item.uid){
                                    <tr>
                                        <td>{{ item.created_at | date: 'dd-MM-yyyy' }}</td>
                                        <td>{{ item.first_name }}</td>
                                        <td>
                                            <span>{{ item.last_name }}</span>
                                        </td>
                                        <td>{{ item.email }}</td>
                                        <td>
                                            <span>{{ item.lease_amount }}</span>
                                        </td>
                                        <td>
                                            <span>{{ item.lease_end_date | date:'dd-MM-yyyy' }}</span>
                                        </td>
                                        <!-- <td>
                                            @if(item.status == 'Pending'){
                                            <span class="badge badge-danger light border-0">{{item.status}}</span>
                                            } @else {
                                            <span class="badge badge-success light border-0">{{item.status}}</span>
                                            }
                                        </td> -->
                                        <td>
                                            <span>{{ item.property_name }}</span>
                                        </td>
                                        <td>{{ item.is_active ? 'Yes' : 'No' }}</td>
                                        <td class="text-center">
                                            <button *ngIf="checkEditTenant" type="button" class="btn btn-success shadow btn-xs sharp mb-1 me-2" (click)="viewTenant(item.uid)"><i class="fa fa-eye"></i></button>
                                             <button *ngIf="checkDeleteTenant" type="button" class="btn btn-danger shadow btn-xs sharp mb-1" (click)="deleteUser(item.uid)"><i class="fa fa-trash"></i></button>
                                        </td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                        <div class="dataTables_info" id="example5_info" role="status" aria-live="polite" *ngIf="allData.data?.length">Showing {{allData.startPage}} to
                            {{allData.endPage}} of {{ totalPage }} entries
                        </div>
                            <div class="dataTables_paginate paging_simple_numbers pt-2" *ngIf="totalPage">
                                <app-pagination [totalPage]="pageCount" [page]="page" (newPage)="pageChange($event)"></app-pagination>
                            </div>
                        </div>

                        <app-tenant-add (addTenantEvent)="addTenant($event)"></app-tenant-add>

                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
